import "@theme/front/init.scss";

import "bootstrap-front/js/dist/dropdown";
import "bootstrap-front/js/dist/collapse";
import "bootstrap-front/js/dist/carousel"
import "bootstrap-front/js/dist/util"

import "nette.ajax.js/nette.ajax";

import "lightbox2/dist/css/lightbox.css";
// eslint-disable-next-line no-unused-vars
import lightbox from "lightbox2/dist/js/lightbox";

import Nette from "@/front/netteForms";
Nette.initOnLoad();
window.Nette = Nette;

import naja from "naja";

const links = document.querySelectorAll(".n-link");
const navbarUl = document.querySelector("#navbar");
const nav = document.querySelector("nav");

function stickyNavbar() {
    const currentScrollPos = window.scrollY;
    if (currentScrollPos > 200 && window.innerWidth > 992) {
        nav.classList.remove("navbar-homepage");
    } else if (currentScrollPos < 190) {
        nav.classList.add("navbar-homepage");
    }
}

document.addEventListener("DOMContentLoaded", () => {
    naja.initialize()

    // select competitions by year
    const selectYear = document.querySelector('#selectYear');
    if (selectYear) {
        selectYear.addEventListener('change', () => {
            const address = window.location.pathname.split('-')
            const spinner = document.querySelector('#selectYearSpinner');

            spinner.classList.remove('d-none');
            naja.makeRequest('GET', address[0] + '-' + selectYear.value).then((r) => console.log('hide'))
        })
    }

    // close navbar on link click
    links.forEach((link) => {
        link.addEventListener("click", () => {
            if (navbarUl.classList.contains("show")) {
                navbarUl.classList.remove("show");
            }
        });
    });

    // on scroll events
    // eslint-disable-next-line no-undef
    stickyNavbar();
    // eslint-disable-next-line no-undef
    window.addEventListener("scroll", stickyNavbar);

    // smooth scroll
    // Add smooth scrolling to all links
    $(".scroll").on("click", function(event) {

        // Make sure this.hash has a value before overriding default behavior
        if (this.hash !== "") {
            // Prevent default anchor click behavior
            event.preventDefault();

            // Store hash
            const hash = this.hash;

            // Using jQuery's animate() method to add smooth page scroll
            // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
            $("html, body").animate({
                scrollTop: $(hash).offset().top - 100
            }, 600, function(){

                // Add hash (#) to URL when done scrolling (default click behavior)
                window.location.hash = hash;
            });
        } // End if
    });
});
